import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISettlementLettersState } from 'types/SettlementLetters';
import {
	getSettlementLettersThunk,
	getSettlementLetterThunk,
} from './settlementLettersThunk';

const initialState: ISettlementLettersState = {
	loaded: false,
	errorCode: 0,
	errorMessage: '',
	documents: [],
	document: undefined,
	expandView: true,
};
export const getSettlementLetters = createAsyncThunk(
	'settlementLetters/getSettlementLetters',
	getSettlementLettersThunk,
);

export const getSettlementLetter = createAsyncThunk(
	'settlementLetters/getSettlementLetter',
	getSettlementLetterThunk,
);

const settlementLettersSlice = createSlice({
	name: 'settlementLetters',
	initialState,
	reducers: {
		toggleExpandView: state => {
			state.expandView = !state.expandView;
		},
		resetDocuments: state => {
			state.errorCode = 0;
			state.errorMessage = '';
			state.loaded = false;
			state.documents = [];
			state.document = undefined;
			state.expandView = true;
		},
	},
	extraReducers: builder => {
		builder
			.addCase(getSettlementLetters.fulfilled, (state, { payload }) => {
				state.errorCode = 0;
				state.errorMessage = '';
				state.documents = payload.documents;
				state.loaded = true;
			})
			.addCase(getSettlementLetters.rejected, (state, { payload }) => {})
			.addCase(
				getSettlementLetter.fulfilled,
				(state, { payload }: PayloadAction<string>) => {
					state.errorCode = 0;
					state.errorMessage = '';
					state.document = payload;
				},
			)
			.addCase(getSettlementLetter.rejected, (state, { payload }) => {});
	},
});

export const { resetDocuments, toggleExpandView } =
	settlementLettersSlice.actions;
export default settlementLettersSlice.reducer;
